<template>
  <OutlinedIcon>
    <v-icon small>mdi-flask-outline</v-icon>
  </OutlinedIcon>
</template>

<script>
import OutlinedIcon from './OutlinedIcon.vue'
export default {
  components: { OutlinedIcon },
}
</script>

<style lang="scss" scoped>
i {
  margin: 4px;
}
</style>